import React from "react";
import { DatavizDemographic } from "@radarly/models/dataviz";
import { SearchFragmentDemographic } from "@radarly/models/search";
import { useFragmentData } from "../../data";
import Loading from "../../loading";
import Inner from "./inner";

export interface SharedWidgetsDemographicPyramidProps {
  project: number;
  fragment: SearchFragmentDemographic;
  dataviz: DatavizDemographic;
  className?: string;
  forceReload?: boolean;
  onClickRange?: (range: string) => void;
  onClickRangeGender?: (range: string, gender: string) => void;
  disableAnimation?: boolean;
  isFullscreen?: boolean;
  closeFullscreen?: () => void;
}

export default function SharedWidgetsDemographicPyramid({
  project,
  fragment,
  forceReload,
  isFullscreen,
  closeFullscreen,
  onClickRange,
  onClickRangeGender,
  ...props
}: SharedWidgetsDemographicPyramidProps) {
  const { loading, data } = useFragmentData(project, fragment);
  const _onClickRangeGender = (range: string, gender: string) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickRangeGender(range, gender);
  };

  const _onClickRange = (range: string) => {
    if (isFullscreen) {
      closeFullscreen();
    }
    onClickRange(range);
  };
  return (
    <Loading loading={loading} forceReload={forceReload}>
      <Inner
        data={data}
        fragment={fragment}
        onClickRangeGender={_onClickRangeGender}
        onClickRange={_onClickRange}
        {...props}
      />
    </Loading>
  );
}
